import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';
import { localize } from 'vee-validate';

import i18n from '@/libs/i18n';

import '@/libs/acl';
import '@/libs/sweet-alerts';
import '@/@core/utils/validations/validations';

// Vue screen
import VueScreen from 'vue-screen';

/* import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs); */

/* // Vue Scroll
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo) */

// Vue Touch Events
import Vue2TouchEvents from 'vue2-touch-events';

// VueClipboard
import VueClipboard from 'vue-clipboard2';

// Vue Mask
import VueMask from 'v-mask';

// Social sharing
import VueSocialSharing from 'vue-social-sharing';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {
  faTwitter, faFacebookF, faInstagram, faWhatsapp, faLinkedinIn, faYoutube, faTelegram,
} from '@fortawesome/free-brands-svg-icons';

// Global Components
import './global-components/global-components';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/toastification';

// Animate CSS
import 'animate.css';

// SweetAlertIcons
import SweetAlertIcons from 'vue-sweetalert-icons';
import api from '@/libs/axios';
import { setupMetaPixel } from '@/libs/meta-pixel';
import App from './App.vue';
import store from './store';
import router from './router';

import './registerServiceWorker';

Vue.use(VueScreen);
Vue.use(Vue2TouchEvents);
Vue.use(VueClipboard);
Vue.use(VueMask);
Vue.use(VueSocialSharing);

/* add icons to the library */
library.add(faTwitter, faFacebookF, faInstagram, faWhatsapp, faLinkedinIn, faYoutube, faTelegram);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(SweetAlertIcons);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css'); // For form-wizard

Vue.config.productionTip = false;

const resolveValidationLocale = (locale = 'pt') => {
  const normalizedLocale = String(locale || 'pt').trim().toLowerCase();

  if (normalizedLocale.startsWith('pt')) {
    return 'pt';
  }

  if (normalizedLocale.startsWith('es')) {
    return 'es';
  }

  return 'en';
};
const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');

localize(resolveValidationLocale(app.$i18n.locale));

app.$watch(
  () => app.$i18n.locale,
  locale => {
    localize(resolveValidationLocale(locale));
  },
);

const frontUrl = process.env.VUE_APP_FRONT_URL || '';
const shouldForceFrontRedirect = process.env.NODE_ENV === 'production'
  && frontUrl
  && !['https:', 'https'].includes(window.location.protocol)
  && window.location.href !== frontUrl;

if (shouldForceFrontRedirect) {
  window.location.href = frontUrl;
}

if (!shouldForceFrontRedirect) {
  setupMetaPixel({
    apiClient: api,
    storeNick: process.env.VUE_APP_STORE_NICK || 'psiqueasy',
    initialRoute: router.currentRoute,
  });
}

console.log(
  'Developed by \n%cOLIVEIRACORP', 'color: #7289DA; font-size: 40px; font-weight: bold;',
  '\n       https://www.oliveiracorp.com.br',
);
